export { default } from "./ProjectedFinancialPlanAreaChart";
